import {
  GitMerge,
  GitPullRequest,
  GitPullRequestClosed,
  GitPullRequestDraft,
  type LucideIcon,
} from "lucide-react";
import type { ManagedPr } from "./types";

/** Compact PR ref for pills and sidebar rows, e.g. `web#421`. */
export function managedPrRef(
  pr: Pick<ManagedPr, "repository" | "pr_number">,
): string {
  return `${pr.repository.split("/")[1] ?? pr.repository}#${pr.pr_number}`;
}

/**
 * Icon, label and text color per PR status, shared by the PR cards, sidebar
 * badges and inline PR links so a merged PR reads purple everywhere.
 */
export const PR_STATUS_PRESENTATION: Record<
  ManagedPr["status"],
  { Icon: LucideIcon; label: string; colorClass: string }
> = {
  open: { Icon: GitPullRequest, label: "Open", colorClass: "text-ds-green" },
  draft: {
    Icon: GitPullRequestDraft,
    label: "Draft",
    colorClass: "text-neutral-500 dark:text-neutral-400",
  },
  merged: { Icon: GitMerge, label: "Merged", colorClass: "text-ds-purple" },
  closed: {
    Icon: GitPullRequestClosed,
    label: "Closed",
    colorClass: "text-ds-red",
  },
};
